import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjReport"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 1.96429C2.5 1.70787 2.70787 1.5 2.96429 1.5H13.0357C13.2921 1.5 13.5 1.70787 13.5 1.96429V10.7857H13.5L13.5 10.7857V14.5H2.96429C2.70787 14.5 2.5 14.2921 2.5 14.0357V1.96429ZM13.5 10.7857V9.85712H9.38091C9.12449 9.85712 8.91663 10.065 8.91663 10.3214V14.5H9.83337V11.7143C9.83337 11.2014 10.2491 10.7857 10.7619 10.7857H13.5ZM9.83339 14.5L13.5 10.7858V14.5H9.83339ZM3.875 4.05355C3.875 3.92535 3.97893 3.82141 4.10714 3.82141H10.9762C11.1044 3.82141 11.2083 3.92534 11.2083 4.05355V4.98213C11.2083 5.11033 11.1044 5.21427 10.9762 5.21427H4.10714C3.97893 5.21427 3.875 5.11033 3.875 4.98213V4.05355ZM4.10714 6.60712C3.97893 6.60712 3.875 6.71105 3.875 6.83926V7.76783C3.875 7.89604 3.97893 7.99997 4.10714 7.99997H8.22619C8.3544 7.99997 8.45833 7.89604 8.45833 7.76783V6.83926C8.45833 6.71105 8.3544 6.60712 8.22619 6.60712H4.10714Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_report = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_report as default };
